import * as fabricTypes from 'fabric'
import { fabric } from '~/utils/editor/fabric'
import { FillType } from '~/static/enums/components/color-input'
import { parseRgba, makeRgba } from '~/utils/ColorpickerHelper'

export interface Rgba {
  r: number
  g: number
  b: number
  a: number
}

export const applyAlpha = (rgba: string, alpha: number): string => {
  const parsedRgba = parseRgba(rgba)
  parsedRgba.a = alpha / 100
  return makeRgba(parsedRgba)
}

export const assignNewColorAndAlpha = (
  type: FillType,
  oldColor: FabricGradientOptions | string,
  oldOpacity: number,
  color?: FabricGradientOptions | string,
  opacity?: number,
): {
  color: FabricGradientOptions | string
  opacity: number
} => {
  const result = {
    color: oldColor,
    opacity: oldOpacity,
  }
  if (type === FillType.Solid) {
    if (color !== undefined) {
      result.color = color
      result.opacity = Math.round(parseRgba(<string>color).a * 100)
    } else if (opacity !== undefined) {
      result.opacity = opacity
      result.color = applyAlpha(<string>oldColor, opacity)
    }
  } else {
    result.color = color ?? oldColor
    result.opacity = 100
  }
  return result
}

export const makeFabricGradient = (
  width: number,
  height: number,
  color: FabricGradientOptions,
  offsetX?: number,
  offsetY?: number,
): fabricTypes.Gradient<FillType.Linear> | fabricTypes.Gradient<FillType.Radial> => {
  const colorStops: fabricTypes.ColorStop[] = []
  color.colorStops?.forEach((point) => {
    colorStops.push({
      offset: point.offset,
      color: point.color,
    })
  })
  const gradient = new fabric.Gradient({
    type: color.type,
    colorStops: colorStops,
    coords: (color.type === FillType.Radial) ?
      {
        x1: width / 2,
        y1: height / 2,
        r1: 0,
        x2: width / 2,
        y2: height / 2,
        r2: width / 2,
      } :
      {
        x1: width * (color.x1Coeff ?? 1),
        y1: height * (color.y1Coeff ?? 1),
        x2: width * (color.x2Coeff ?? 0),
        y2: height * (color.y2Coeff ?? 0),
      },
  })
  if (offsetX !== undefined) {
    gradient.offsetX = offsetX
  }
  if (offsetY !== undefined) {
    gradient.offsetY = offsetY
  }
  return gradient as fabricTypes.Gradient<FillType.Linear> | fabricTypes.Gradient<FillType.Radial>
}
